import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faSleigh } from '@fortawesome/free-solid-svg-icons';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'shared-confirmation-dialog',
  templateUrl: './shared-confirmation-dialog.component.html',
  styleUrls: ['./shared-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedConfirmationDialogComponent {
  hideCancel = false;
  showCancelBtn = false;
  checked = false;
  hasThirdButton = false;
  checkedEntityFiles = [];
  constructor(private dialogRef: MatDialogRef<SharedConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data?.hideCancel) {
      this.hideCancel = true;
    }
    if (this.data?.showCancelBtn) {
      this.showCancelBtn = true;
    }
    if (this.data?.hasThirdButton) {
      this.hasThirdButton = true;
    }
  }

  confirmDialog() {
    if (this.checked) {
      return this.dialogRef.close({
        confirmation: true,
        deleteAllChecked: true,
      });
    } else if (this.checkedEntityFiles.length > 0) {
      return this.dialogRef.close({
        confirmation: true,
        entityIds: this.checkedEntityFiles.map((f) => f.vault_id),
      });
    } else {
      this.dialogRef.close({
        confirmation: true,
      });
    }
  }

  closeDialog(isCancel = false) {
    if (this.data?.hasThirdButton && this.data?.isFromAddDocument) {
      this.dialogRef.close({ isCancel });
    } else {
      this.dialogRef.close();
    }
  }
  selectOne(event) {
    this.checked = event.checked;
  }
  selectOneEntityFile(event, file) {
    if (event.checked) {
      this.checkedEntityFiles = [...this.checkedEntityFiles, file];
    } else {
      this.checkedEntityFiles = this.checkedEntityFiles.filter((f) => f !== file);
    }
  }
}
